module.exports = __webpack_public_path__ + "img/img09.c4155d9b.png";